export const FINANCING_ENDING_EMAIL_DIALOG_ID = 'financingEndingEmailDialog';
